/* global $ */
/* eslint no-bitwise: 0 */

const generateUniqueId = () =>
  [...Array(10)].map(() => (~~(Math.random() * 36)).toString(36)).join('');

const uniqueId = generateUniqueId();

$.$body.find('.image-slider').slick({
  // https://github.com/kenwheeler/slick/#settings
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  draggable: true,
  fade: true,
  // adaptiveHeight: true,
  accessibility: true,
  // focusOnChange: true,
  // ^ prefer using a custom afterChange callback to focus that takes sticky header into account
  prevArrow: `<div class="slick-prev"><svg id="left-chevron-small-title-${uniqueId}" width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path d="M10.8569 25.375L12.0894 24.1697L3.28969 15.3609L29 15.3609L29 13.6391L3.28969 13.6391L12.0894 4.82125L10.8569 3.625L-9.56626e-07 14.5L10.8569 25.375Z"/></g><defs><clipPath id="clip0"><rect width="29" height="29" fill="white" transform="translate(29 29) rotate(-180)"/></clipPath></defs></svg></div>`,
  nextArrow: `<div class="slick-next"><svg id="right-arrow-small-desc-${uniqueId}" width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.1431 3.625L16.9106 4.83031L25.7103 13.6391H0V15.3609H25.7103L16.9106 24.1788L18.1431 25.375L29 14.5L18.1431 3.625Z" /></svg></div>`,
});
$.$body.find('.latest-stories-slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  draggable: true,
  mobileFirst: true,
  accessibility: true,
  prevArrow: '<button class="slick-arrow slick-prev">Previous</button>',
  nextArrow: '<button class="slick-arrow slick-next">Next</button>',
  dots: true,
  appendArrows: '.latest-stories-slider-nav',
  appendDots: '.latest-stories-slider-nav',
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: true,
      },
    },
  ],
});

if ($.$body.find('.landing-confirmed-schools-slider').length) {
  const slider = $('.landing-confirmed-schools-slider');
  const card = $('.landing-confirmed-schools-card');
  const cardPhoto = card.find('.photo');
  const cardDate = card.find('.date');
  const cardTitle = card.find('.title');

  slider.on('click', (e) => {
    const $this = $(e.target.closest('.item'));
    if ($this.length) {
      const dataPhoto = $this.data('photo');
      const dataDate = $this.data('date');
      const dataTitle = $this.data('title');

      if (window.innerWidth >= 1024) {
        if (!$this.hasClass('active')) {
          slider.find('.item.active').removeClass('active');
          $this.addClass('active');
          card.addClass('hide-animation');
          setTimeout(() => {
            card.removeClass('hide-animation');
            cardPhoto.removeAttr('style');
            cardPhoto.css('background-image', 'url(' + dataPhoto + ')');
            cardDate.text(dataDate);
            cardTitle.html(dataTitle);
          }, 400);
        }
      } else {
        $.$body.addClass('card-showed');
        cardPhoto.removeAttr('style');
        cardPhoto.css('background-image', 'url(' + dataPhoto + ')');
        cardDate.text(dataDate);
        cardTitle.html(dataTitle);
      }
    }
  });

  card.on('click', '.landing-confirmed-schools-card-close , .overlay', () => {
    $.$body.removeClass('card-showed');
  });

  $.$body.find('.landing-confirmed-schools-slider').slick({
    infinite: false,
    rows: 3,
    slidesToShow: 2,
    slidesToScroll: 2,
    draggable: true,
    mobileFirst: true,
    accessibility: true,
    prevArrow:
      '<button class="slick-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">\n' +
      '  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.6721 14.5L10.6666 13.5874L6.42245 8.50005L10.6666 3.41264L9.67218 2.5L4.66663 8.50005L9.6721 14.5Z" fill="black"/>\n' +
      '</svg>Prev</button>',
    nextArrow:
      '<button class="slick-arrow slick-next">Next<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">\n' +
      '  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.66128 14.5L4.66675 13.5874L8.91093 8.50004L4.66675 3.41264L5.6612 2.5L10.6667 8.50004L5.66128 14.5Z" fill="black"/>\n' +
      '</svg></button>',
    dots: true,
    appendArrows: '.landing-confirmed-schools-slider-nav',
    appendDots: '.landing-confirmed-schools-slider-nav',
    responsive: [
      {
        breakpoint: 567,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
    ],
  });
}
